import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const messengerContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100vw',
  overflow: 'hidden'
};

export const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column' as const,
  minHeight: '100vh',
  background: '#fff'
};

export const messageInputFormControlStyle: CSSProperties = {
  position: 'sticky',
  bottom: 0,
  padding: '10px 15px',
  background: '#fff',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  alignItems: 'center'
};

export const verifiedPhotoRequiredStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10px 15px',
  width: '100%',
  textAlign: 'center'
};

export const verifiedPhotoRequiredTextStyle: CSSProperties = {
  fontSize: '12px',
  color: '#b4b6bc',
  fontFamily: UIConfig.Fonts.Primary
};

export const messageInputTextareaStyle = () => ({
  flex: 1,
  resize: 'none' as const,
  borderRadius: '14px',
  padding: '10px 15px',
  border: '1px solid #ccc',
  outline: 'none',
  fontSize: '15px'
  // overscrollBehavior: 'contain',
  // touchAction: 'none'
  // overflow: 'hidden !important',
  // touchAction: 'none'
  // marginBottom: isKeyboardOpen ? 0 : '15px'
  // marginBottom: 7
});